/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} General_Delete_Relations_Blocked_SuffixInputs */

const en_general_delete_relations_blocked_suffix = /** @type {(inputs: General_Delete_Relations_Blocked_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.`)
};

const de_general_delete_relations_blocked_suffix = /** @type {(inputs: General_Delete_Relations_Blocked_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.`)
};

/**
* | output |
* | --- |
* | "." |
*
* @param {General_Delete_Relations_Blocked_SuffixInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const general_delete_relations_blocked_suffix = /** @type {((inputs?: General_Delete_Relations_Blocked_SuffixInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<General_Delete_Relations_Blocked_SuffixInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_general_delete_relations_blocked_suffix(inputs)
	return de_general_delete_relations_blocked_suffix(inputs)
});